import { StateService } from "@core-services/state.service";
import { Dictionary } from "@helpers/types";
import { TradableInfo } from "@modules/+new/core/tradables/domain/entities/tradable-info";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";

const initialState: Dictionary<TradableInfo> = {};

@Injectable({
	providedIn: "root"
})
export class TradablesInfoStateService extends StateService<Dictionary<TradableInfo>> {
	constructor() {
		super(initialState);
	}

	public addTradableInfo(id: string, info: TradableInfo): void {
		this.setState({ ...this.state, [id]: { ...info } });
	}

	public selectTradableInfoById(id: string): Observable<TradableInfo> {
		return this.select((state) => state[id]);
	}
}
